<template>
    <DivToVueComponent class="container-fluid main-view" ref="mainView">
        <div class="row">
            <div class="w-100" v-if="mainVueElement">
                <div v-if="openedFeed !== null">
                    <div v-for="(leagues, date) in feedSorted">
                        <LeagueView v-for="(league, name) in leagues"
                                    :feed="league"
                                    :leagueName="name"
                                    @refreshFeed="refreshFeed"
                                    :leagueKey="leagueKey(name, date)"
                                    :key="leagueKey(name, date)"
                                    :id="leagueKey(name, date)"
                                    v-observe-visibility="{
                            callback: visibilityChanged,
                                intersection: {
                                    root: mainVueElement,
                                    rootMargin: '300px',
                                    threshold: 0,
                                },
                            }"
                        />
                    </div>
                </div>
                <div v-else>
                    <b-alert show variant="warning" class="text-center" v-if="openedDate === 'today'">
                        {{translate('general', 'Sorry there are no events today', language)}}
                    </b-alert>
                    <b-alert show variant="warning" class="text-center" v-else-if="openedDate === 'live'">
                        {{translate('general', 'Sorry there are no live events', language)}}
                    </b-alert>
                    <b-alert show variant="warning" class="text-center" v-else-if="openedDate === 'early'">
                        {{translate('general', 'Sorry there are no upcoming events', language)}}
                    </b-alert>
                    <b-alert show variant="warning" class="text-center" v-else-if="openedDate === 'mixParlay'">
                        {{translate('general', 'Sorry there are no events', language)}}
                    </b-alert>
                </div>
            </div>
        </div>
    </DivToVueComponent>
</template>

<script>
import LeagueView from "./LeagueView";
import DivToVueComponent from "./DivToVueComponent";
import { mapGetters } from 'vuex'
const _ = require('lodash')
import {formattedKeyLeagueName} from "../services/FeedService"

export default {
    name: 'MainView',
    components: {
        DivToVueComponent,
        LeagueView
    },
    computed: {
        ...mapGetters({
            language: 'settings/language',
        })
    },
    props:{
        openedFeed : Object,
        openedDate : String,
    },
    watch: {
        'openedFeed': function() {
            this.feedSortedByDate()
        },
    },
    data() {
        return {
            mainVueElement: null,
            feedSorted: [],
        }
    },
    methods: {
        feedSortedByDate() {
            let sortedDate = _.orderBy(_.keys(this.openedFeed))
            let feedSorted = []
            _.forEach(sortedDate, (date) => {
                feedSorted.push(this.openedFeed[date])
            })
            this.feedSorted = feedSorted
        },
        leagueKey(leagueName, date) {
            return formattedKeyLeagueName(leagueName, date)
        },
        refreshFeed(){
            this.$emit('refreshFeed')
        },
        visibilityChanged (isVisible, entry) {
            this.$store.dispatch('leagues/changeVisibility', {key: entry.target.id, isVisible})
        }
    },
    mounted() {
        this.feedSortedByDate();
        this.mainVueElement = this.$refs.mainView.$el
        let leaguesVisible = {}
        _.forEach(this.openedFeed, (feed, leagueName) => {
            _.assign(leaguesVisible, {[this.leagueKey(leagueName)] : false})
        })

        this.$store.dispatch('leagues/setLeagueViews', leaguesVisible)
    }
}
</script>